import {} from "react";
import { useApp } from "@/state/app-context";
import { useLongPress } from "./use-long-press";
/**
 * Long-press → enter collection-multiselect mode (with this card seeded).
 *
 * Thin wrapper over the shared `useLongPress` primitive. No tap path is
 * provided here — collection cards rely on React's native `onClick` to
 * branch between "open" and "toggle selection" behaviors, so we don't
 * need the touch listener to dispatch taps directly (and skipping
 * `onTap` lets the touchend listener stay passive, which keeps the
 * native click flowing through to React).
 *
 * No-op while any multiselect mode is already active — toggling
 * happens via the card's regular click handler.
 */
export function useLongPressCollectionSelect(collectionId, cardRef) {
    const app = useApp();
    useLongPress(cardRef, {
        haptic: "medium",
        onLongPress: () => {
            if (app.state.ui.isMultiselectMode)
                return;
            app.enterCollectionMultiselectMode(collectionId);
        },
    });
}
